import type { RootState } from 'features/app/store/store';

export const selectIsAppConfigRetrievedSuccessful = ({
  appConfig,
}: RootState) => appConfig.isAppConfigRetrievedSuccessful;
